// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1inCI","insightsList":"newBusinessInsightsMenu_insightsList__F4W26","active":"newBusinessInsightsMenu_active__3-IYw"};